/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Badge_Verified_NfpInputs */

const en_badge_verified_nfp = /** @type {(inputs: Badge_Verified_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified Non-Profit`)
};

const es_badge_verified_nfp = /** @type {(inputs: Badge_Verified_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ONG Verificada`)
};

const fr_badge_verified_nfp = /** @type {(inputs: Badge_Verified_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Association Vérifiée`)
};

const de_badge_verified_nfp = /** @type {(inputs: Badge_Verified_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifizierte NGO`)
};

const id_badge_verified_nfp = /** @type {(inputs: Badge_Verified_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non-Profit Terverifikasi`)
};

/** @type {(inputs: Badge_Verified_NfpInputs) => LocalizedString} */
const ja_badge_verified_nfp = en_badge_verified_nfp;

/** @type {(inputs: Badge_Verified_NfpInputs) => LocalizedString} */
const zh_badge_verified_nfp = en_badge_verified_nfp;

/** @type {(inputs: Badge_Verified_NfpInputs) => LocalizedString} */
const ar_badge_verified_nfp = en_badge_verified_nfp;

/** @type {(inputs: Badge_Verified_NfpInputs) => LocalizedString} */
const it_badge_verified_nfp = en_badge_verified_nfp;

/** @type {(inputs: Badge_Verified_NfpInputs) => LocalizedString} */
const ru_badge_verified_nfp = en_badge_verified_nfp;

/** @type {(inputs: Badge_Verified_NfpInputs) => LocalizedString} */
const pt_badge_verified_nfp = en_badge_verified_nfp;

/** @type {(inputs: Badge_Verified_NfpInputs) => LocalizedString} */
const ko_badge_verified_nfp = en_badge_verified_nfp;

/**
* | output |
* | --- |
* | "Verified Non-Profit" |
*
* @param {Badge_Verified_NfpInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const badge_verified_nfp = /** @type {((inputs?: Badge_Verified_NfpInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Verified_NfpInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_badge_verified_nfp(inputs)
	if (locale === "es") return es_badge_verified_nfp(inputs)
	if (locale === "fr") return fr_badge_verified_nfp(inputs)
	if (locale === "de") return de_badge_verified_nfp(inputs)
	if (locale === "ja") return ja_badge_verified_nfp(inputs)
	if (locale === "zh") return zh_badge_verified_nfp(inputs)
	if (locale === "ar") return ar_badge_verified_nfp(inputs)
	if (locale === "id") return id_badge_verified_nfp(inputs)
	if (locale === "it") return it_badge_verified_nfp(inputs)
	if (locale === "ru") return ru_badge_verified_nfp(inputs)
	if (locale === "pt") return pt_badge_verified_nfp(inputs)
	return ko_badge_verified_nfp(inputs)
});